<template>
  <div class="callLogs">
    <el-row>
      <el-col :span="24">{{ companyName }}</el-col>
    </el-row>
    <el-tabs type="border-card" class="mt-10">
      <el-tab-pane label="服务对接人号码">
        <el-row>
          <el-col :span="6" class="mt-10" v-for="(phone, index) in callPhone3" :key="index">
            <span class="callNum" @click="call(phone)">{{ phone }} <i class="el-icon-phone-outline" style="color: rgb(87, 135, 255)"></i></span>
          </el-col>
        </el-row>
        <el-table :data="pageData3" size="mini" border style="width: 100%; margin-top: .2rem">
          <el-table-column label='姓名'>
            <template slot-scope="scope">
              {{scope.row.user ? scope.row.user.username : '测试'}}
            </template>
          </el-table-column>
          <el-table-column label='主叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.caller" placement="top">
                <span class="hide-style">{{scope.row.caller}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='被叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.callee" placement="top">
                <span class="hide-style">{{scope.row.callee}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='通话状态'>
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.ul_fail_reason" :content="scope.row.ul_fail_reason" placement="top">
                <span class="hide-style">{{scope.row.ul_fail_reason}}</span>
              </el-tooltip>
              <span v-else>待处理</span>
            </template>
          </el-table-column>
          <el-table-column label='时长(秒)'>
            <template slot-scope="scope">
              <span>{{scope.row.billsec}}</span>
              <i v-if="scope.row.record_flag === 1" style="color: #5cb6ff; font-size: .4rem; cursor: pointer;" class="el-icon-mic" @click="play(scope.row.file_storage, scope.row.record_file_download_url)"></i>
            </template>
          </el-table-column>
          <el-table-column label='呼叫时间'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.fwd_start_time" placement="top">
                <span class="hide-style">{{scope.row.fwd_start_time}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="mt-10 text-r"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false"
          :current-page="pageOption3.currentPage"
          :page-size="pageOption3.pageSize"
          :total="pageOption3.total"
          @current-change="handleCurrentChange3">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="会员号码">
        <el-row>
          <el-col :span="6" class="mt-10" v-for="(phone, index) in callPhone" :key="index">
            <span class="callNum" @click="call(phone)">{{ phone }} <i class="el-icon-phone-outline" style="color: rgb(87, 135, 255)"></i></span>
          </el-col>
        </el-row>
        <el-table :data="pageData" size="mini" border style="width: 100%; margin-top: .2rem">
          <el-table-column label='姓名'>
            <template slot-scope="scope">
              {{scope.row.user ? scope.row.user.username : '测试'}}
            </template>
          </el-table-column>
          <el-table-column label='主叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.caller" placement="top">
                <span class="hide-style">{{scope.row.caller}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='被叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.callee" placement="top">
                <span class="hide-style">{{scope.row.callee}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='通话状态'>
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.ul_fail_reason" :content="scope.row.ul_fail_reason" placement="top">
                <span class="hide-style">{{scope.row.ul_fail_reason}}</span>
              </el-tooltip>
              <span v-else>待处理</span>
            </template>
          </el-table-column>
          <el-table-column label='时长(秒)'>
            <template slot-scope="scope">
              <span>{{scope.row.billsec}}</span>
              <i v-if="scope.row.record_flag === 1" style="color: #5cb6ff; font-size: .4rem; cursor: pointer;" class="el-icon-mic" @click="play(scope.row.file_storage, scope.row.record_file_download_url)"></i>
            </template>
          </el-table-column>
          <el-table-column label='呼叫时间'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.fwd_start_time" placement="top">
                <span class="hide-style">{{scope.row.fwd_start_time}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="mt-10 text-r"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false"
          :current-page="pageOption.currentPage"
          :page-size="pageOption.pageSize"
          :total="pageOption.total"
          @current-change="handleCurrentChange">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="下单号码" name="choosePhone">
        <el-row>
          <el-col :span="6" class="mt-10" v-for="(phone, index) in callPhone1" :key="index">
            <!-- <span class="callNum" @click="call(phone)">{{ phone.substr(0,5) }} <i class="el-icon-phone-outline" style="color: rgb(87, 135, 255)"></i></span> -->
            <span class="callNum" @click="call(phone)">{{ phone }} <i class="el-icon-phone-outline" style="color: rgb(87, 135, 255)"></i></span>
          </el-col>
          <!-- <el-col :span="6" class="mt-10">
            <span>客户所在城市:</span>
            <span>{{ customerCity ? customerCity : '暂无' }}</span>
          </el-col>
          <el-col :span="6" class="mt-10">
            <span>手机所属省份:</span>
            <span>{{ phoneProvice ? phoneProvice : '暂无' }}</span>
          </el-col> -->
        </el-row>
        <el-table :data="pageData1" size="mini" border style="width: 100%; margin-top: .2rem">
          <el-table-column label='姓名'>
            <template slot-scope="scope">
              {{scope.row.user ? scope.row.user.username : '测试'}}
            </template>
          </el-table-column>
          <el-table-column label='主叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.caller" placement="top">
                <span class="hide-style">{{scope.row.caller}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='被叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.callee" placement="top">
                <span class="hide-style">{{scope.row.callee}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='通话状态'>
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.ul_fail_reason" :content="scope.row.ul_fail_reason" placement="top">
                <span class="hide-style">{{scope.row.ul_fail_reason}}</span>
              </el-tooltip>
              <span v-else>待处理</span>
            </template>
          </el-table-column>
          <el-table-column label='时长(秒)'>
            <template slot-scope="scope">
              <span>{{scope.row.billsec}}</span>
              <i v-if="scope.row.record_flag === 1" style="color: #5cb6ff; font-size: .4rem; cursor: pointer;" class="el-icon-mic" @click="play(scope.row.file_storage, scope.row.record_file_download_url)"></i>
            </template>
          </el-table-column>
          <el-table-column label='呼叫时间'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.fwd_start_time" placement="top">
                <span class="hide-style">{{scope.row.fwd_start_time}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="mt-10 text-r"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false"
          :current-page="pageOption1.currentPage"
          :page-size="pageOption1.pageSize"
          :total="pageOption1.total"
          @current-change="handleCurrentChange1">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="法人号码">
        <el-row>
          <el-col :span="6" class="mt-10" v-for="(phone, index) in callPhone2" :key="index">
            <span class="callNum" @click="call(phone)">{{ phone }} <i class="el-icon-phone-outline" style="color: rgb(87, 135, 255)"></i></span>
          </el-col>
        </el-row>
        <el-table :data="pageData2" size="mini" border style="width: 100%; margin-top: .2rem">
          <el-table-column label='姓名'>
            <template slot-scope="scope">
              {{scope.row.user ? scope.row.user.username : '测试'}}
            </template>
          </el-table-column>
          <el-table-column label='主叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.caller" placement="top">
                <span class="hide-style">{{scope.row.caller}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='被叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.callee" placement="top">
                <span class="hide-style">{{scope.row.callee}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='通话状态'>
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.ul_fail_reason" :content="scope.row.ul_fail_reason" placement="top">
                <span class="hide-style">{{scope.row.ul_fail_reason}}</span>
              </el-tooltip>
              <span v-else>待处理</span>
            </template>
          </el-table-column>
          <el-table-column label='时长(秒)'>
            <template slot-scope="scope">
              <span>{{scope.row.billsec}}</span>
              <i v-if="scope.row.record_flag === 1" style="color: #5cb6ff; font-size: .4rem; cursor: pointer;" class="el-icon-mic" @click="play(scope.row.file_storage, scope.row.record_file_download_url)"></i>
            </template>
          </el-table-column>
          <el-table-column label='呼叫时间'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.fwd_start_time" placement="top">
                <span class="hide-style">{{scope.row.fwd_start_time}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="mt-10 text-r"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false"
          :current-page="pageOption2.currentPage"
          :page-size="pageOption2.pageSize"
          :total="pageOption2.total"
          @current-change="handleCurrentChange2">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="播放" :visible.sync="dialogPlayVisible" :append-to-body="true" :before-close="dialogPlayVisibleBeforeClose">
      <el-row class="playCon">
        <el-card class="card" :body-style="{ padding: '10px' }">
          <div id="waveform" ref="waveform"></div>
        </el-card>
        <div style="padding: 10px" id="wave-timeline" ref="wave-timeline"></div>
      </el-row>
      <div class="text-c">
        <el-button type="primary" @click="playMusic" size="mini">
          <i :class="[isPlay ? 'el-icon-video-pause' : 'el-icon-video-play']"></i>
          {{isPlay ? '暂停' : '播放'}}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js'
import Timeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.js'
export default {
  name: 'CallLogs',
  props: {
    company: String,
    phone: Array,
    phone1: Array,
    phone2: Array,
    phone3: Array
  },
  data () {
    return {
      customerCity: '',
      phoneProvice: '',
      companyName: '',
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageData1: [],
      pageOption1: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageData2: [],
      pageOption2: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageData3: [],
      pageOption3: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      wavesurfer: null,
      dialogPlayVisible: false,
      isPlay: false
    }
  },
  watch: {
    company: function (val) {
      this.pageOption.total = 0
      this.pageOption.currentPage = 1
      this.pageOption1.total = 0
      this.pageOption1.currentPage = 1
      this.pageOption2.total = 0
      this.pageOption2.currentPage = 1
      this.pageOption3.total = 0
      this.pageOption3.currentPage = 1
      this.companyName = val || ''
    },
    phone: function (val) {
      this.callPhone = val || []
      this.pageData = []
      if (val.length > 0) this.getLogs()
    },
    phone1: function (val) {
      this.callPhone1 = val || []
      this.pageData1 = []
      if (val.length > 0) this.getLogs1()
    },
    phone2: function (val) {
      this.callPhone2 = val || []
      this.pageData2 = []
      if (val.length > 0) this.getLogs2()
    },
    phone3: function (val) {
      this.callPhone3 = val || []
      this.pageData3 = []
      if (val.length > 0) this.getLogs3()
    }
  },
  methods: {
    choosePhone (tab) {
      if (tab.name === 'choosePhone') {
        this.getPhoneAddress()
      }
    },
    getPhoneAddress () {
      this.$axios.get('api/public_thread/get_customer_province', {
        params: {
          customerPhone: this.callPhone1
        }
      }).then(({data}) => {
        if (data.code === 1) {
          this.customerCity = data.data.custom_city_name
          this.phoneProvice = data.data.phone_province
        }
      }).catch()
    },
    getLogs () {
      this.$axios.post('/api/admin/call_logs?page=' + this.pageOption.currentPage, {phones: this.callPhone})
        .then((res) => {
          let { data } = res
          if (data.code === 200) {
            this.pageData = data.data.records.data
            this.pageOption.total = data.data.records.total
          } else {
            this.$message.warning(data.msg)
          }
        })
    },
    getLogs1 () {
      this.$axios.post('/api/admin/call_logs?page=' + this.pageOption1.currentPage, {phones: this.callPhone1})
        .then((res) => {
          let { data } = res
          if (data.code === 200) {
            this.pageData1 = data.data.records.data
            this.pageOption1.total = data.data.records.total
          } else {
            this.$message.warning(data.msg)
          }
        })
    },
    getLogs2 () {
      this.$axios.post('/api/admin/call_logs?page=' + this.pageOption2.currentPage, {phones: this.callPhone2})
        .then((res) => {
          let { data } = res
          if (data.code === 200) {
            this.pageData2 = data.data.records.data
            this.pageOption2.total = data.data.records.total
          } else {
            this.$message.warning(data.msg)
          }
        })
    },
    getLogs3 () {
      this.$axios.post('/api/admin/call_logs?page=' + this.pageOption3.currentPage, {phones: this.callPhone3})
        .then((res) => {
          let { data } = res
          if (data.code === 200) {
            this.pageData3 = data.data.records.data
            this.pageOption3.total = data.data.records.total
          } else {
            this.$message.warning(data.msg)
          }
        })
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getLogs()
    },
    handleCurrentChange1 (val) {
      this.pageOption1.currentPage = val
      this.getLogs1()
    },
    handleCurrentChange2 (val) {
      this.pageOption2.currentPage = val
      this.getLogs2()
    },
    handleCurrentChange3 (val) {
      this.pageOption3.currentPage = val
      this.getLogs3()
    },
    play (isStorage, url) {
      if (!url) {
        this.$message.error('录音为空')
        return
      }

      if (!isStorage) {
        window.open(url)
        return
      }

      this.$axios.post('/api/admin/callLogs/getObject', {filePath: url})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.dialogPlayVisible = true
            this.waveSurferInit(data.data)
          }
        })
    },
    waveSurferInit (src) {
      this.$nextTick(() => {
        this.wavesurfer = WaveSurfer.create({
          container: this.$refs.waveform,
          barWidth: 1,
          cursorColor: 'black',
          progressColor: 'blue',
          backend: 'MediaElement',
          audioRate: '1',
          plugins: [
            Timeline.create({
              container: '#wave-timeline'
            })
          ]
        })
        this.wavesurfer.load(src)
        let that = this
        this.wavesurfer.on('finish', function () {
          that.isPlay = false
        })
      })
    },
    playMusic () {
      this.wavesurfer.playPause.bind(this.wavesurfer)()
      this.isPlay = this.wavesurfer.isPlaying()
    },
    dialogPlayVisibleBeforeClose (done) {
      this.isPlay = false
      this.wavesurfer.destroy()
      done()
    },
    call (num) {
      if (!num) {
        this.$message.error('手机号为空')
        return
      }

      // this.$axios.post('/api/admin/call_logs/' + num)
      //   .then((res) => {
      //     let { data } = res
      //     if (data.code === 0) {
      //       this.$message.success('调用成功，请注意接听来电')
      //     } else {
      //       this.$message.error(data.msg)
      //     }
      //   })
      this.$axios.post('/api/admin/call_logs_new',{
        num
      })
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success('调用成功，请注意接听来电')
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .callLogs
    .hide-style
      display: inherit
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .mt-10
      margin-top: .2rem
    .text-r
      text-align: right
    .callNum
      cursor: pointer
</style>



// WEBPACK FOOTER //
// src/common/CallLogs.vue